<template>
  <module-block
    :class="[
      `${block.slug}`,
      `home-block`,
    ]"
    :block="block.block"
  >
    <div
      :class="[
        `home-block__inner`,
        block.reversed ? `home-block--reversed` : ``,
        block.large ? `home-block--large` : ``,
        `home-block--${block.block}`,
        !block.large ? `group group--first-last-small` : ``,
      ]"
    >
      <div
        :class="[
          `home-block__image`,
          block.large ? `home-block__image--large` : ``,
          `home-block__image--${block.block}`,
        ]"
        :style="`backgroundImage: url(${block.image.image})`"
      />
      <module-home-content
        :content ="block.content"
      />
    </div>
  </module-block>
</template>

<script>
// Modules
import ModuleBlock from 'modules/Block';
import ModuleHomeContent from 'modules/HomeContent';

// Export
export default {
  name: `home-block`,

  // Compononts
  components: {
    ModuleBlock,
    ModuleHomeContent,
  },

  // Props
  props: {
    block: Object,
  },
};
</script>



// WEBPACK FOOTER //
// Block.vue?acff8ce6